import { render, staticRenderFns } from "./LabSupplyFrameInfoReview.vue?vue&type=template&id=9d680f28"
import script from "./LabSupplyFrameInfoReview.vue?vue&type=script&lang=js"
export * from "./LabSupplyFrameInfoReview.vue?vue&type=script&lang=js"
import style0 from "./LabSupplyFrameInfoReview.vue?vue&type=style&index=0&id=9d680f28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports